import * as React from 'react';

function SvgCreateOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M18 10.8V20a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2h8.374" }),
        React.createElement("path", { fill: "currentColor", d: "M21.797 2.263a.802.802 0 00-1.16-.028l-.62.615a.4.4 0 000 .566l.568.566a.4.4 0 00.567 0l.603-.6c.305-.305.333-.801.042-1.12zM18.767 4.1l-9.026 9.01a.45.45 0 00-.115.197l-.418 1.243a.196.196 0 00.243.243l1.243-.417a.45.45 0 00.196-.116l9.01-9.027a.45.45 0 000-.633l-.497-.5a.45.45 0 00-.636 0z" })));
}

export default SvgCreateOutline;
